<mbs-modal [loading]="loading$ | async"
           [title]="moduleAccount + ':modal.title.exportToPST' | i18next: { format: 'title' }">

  <ng-container modal-body>
    <app-export-to-PST-control [hidden]="loading$ | async"
                               (exportServices)="handleUpdatePayloadForExportToPST($event)"
                               (formValid)="invalidForms($event)" />
  </ng-container>

  <ng-container modalFooter>

    <mbs-button (click)="handleExport()"
                [disabled]="disabled$ | async"
                [loading]="exportLoading$ | async"
                type="primary">
      {{ moduleButton + ':button.exportToPST' | i18next: { format: 'title' } }}
    </mbs-button>

    <mbs-button (click)="handleClose()">
      {{ moduleButton + ':button.cancel' | i18next: { format: 'title' } }}
    </mbs-button>

  </ng-container>

</mbs-modal>
